import { render, staticRenderFns } from "./SwapExercises.vue?vue&type=template&id=f90fcf66&scoped=true&"
import script from "./SwapExercises.vue?vue&type=script&lang=js&"
export * from "./SwapExercises.vue?vue&type=script&lang=js&"
import style0 from "./SwapExercises.vue?vue&type=style&index=0&id=f90fcf66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90fcf66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow,VSnackbar})
